import React, { Component } from "react";

import TextareaAutosize from "react-textarea-autosize";

import { editCommentQuestion } from "../../../../helper/comment_helper";

import LocalizedStrings from "react-localization";
import en from "../../../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class EditAnswer extends Component {
  state = { comment: "" };

  constructor(props) {
    super(props);
    this.state = {
      comment: this.props.answer.name
    };
  }

  render() {
    return (
      <div style={{ flex: 1, flexDirection: "row" }}>
        <div
          className="width_text_question width_text_align_answer"
          style={{ width: "unset" }}
        >
          <div
            className="comment_only"
            style={{
              borderRadius: "10px",
              height: "100%"
            }}
          >
            <TextareaAutosize
              placeholder=""
              type="text"
              onChange={this.handleChangeComment}
              value={this.state.comment}
              style={{
                textAlign: "left",
                width: "calc(100%)",
                paddingRight: "5px",
                paddingLeft: "5px",
                marginTop: "-4px",
                backgroundColor: "transparent",
                border: "none",
                resize: "none"
              }}
            />
          </div>
          <div className="width_image_question" style={{ width: "60px" }}>
            {this.renderPost()}
          </div>
        </div>
      </div>
    );
  }

  handleChangeComment = event => {
    this.setState({ comment: event.target.value });
  };

  renderPost() {
    if (this.state.loaded === false) {
      return <div />;
    }

    const style = {
      display: "block",
      position: "absolute",
      margin: "0px",
      width: "calc(100% - 2px)", // Remove 2px for matching white border of image user
      height: "calc(100% - 2px)", // Remove 2px for matching white border of image user
      top: "0px",
      left: "0px"
    };
    const style_image = {
      left: "0px",
      bottom: "0px"
    };

    return (
      <div className="user_img" style={style_image}>
        <button
          style={style}
          className="btn btn_primary btn_yaystack no_border"
          onClick={this.handlerUpdateComment}
        >
          <label className="cursor_btn" style={{ textTransform: "capitalize" }}>
            {strings.post}
          </label>
        </button>
      </div>
    );
  }

  handlerUpdateComment = event => {
    event.preventDefault();
    // Checking minimum length of the answer
    if (this.state.comment.length < 1) {
      const errors = "Your comment is too short.";
      this.setState({ errors });
      return;
    }
    var fd = new FormData();
    fd.append("answer[name]", this.state.comment);
    this.editCommentCall = editCommentQuestion(this.props.answer.id, fd);
    this.editCommentCall.promise
      .then(answer => {
        console.log(answer);
        this.props.updateAnswer(answer.answer);
      })
      .catch(error => {
        console.log(error);
      });
  };
}

export default EditAnswer;



// WEBPACK FOOTER //
// ./src/components/list/interface/answer/edit_answer.jsx